import { BookWidgetAem } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetMetaDataName } from '../../constants/error-codes.constants';
import { CatalogApiFieldsValue } from '../../models/core-apis/catalog-api.interfaces';
import { TrackJs } from '../../models/trackjs.interfaces';

declare const trackJs: TrackJs;

export const stringToBoolean = (
  stringValue?: string | boolean | null
): boolean => {
  let booleanValue = false;
  if (stringValue === 'true' || stringValue === true) {
    booleanValue = true;
  }
  return booleanValue;
};

export const getQueryParameter = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get(param);
  return paramValue || '';
};

export const trackErrorInTrackJs = (errorCode: string, error: string) => {
  try {
    trackJs?.addMetadata(BookWidgetMetaDataName, errorCode);
    trackJs?.track(error);
    trackJs?.removeMetadata(BookWidgetMetaDataName);
  } catch {
    console.error(error);
  }
};

export const formatErrorCode = (
  genericErrorCode: string,
  httpStatus?: number
) => {
  let errorCode = genericErrorCode;
  if (httpStatus) {
    errorCode = `${genericErrorCode}_${httpStatus}`;
  }
  return errorCode;
};

export const isAlphaNumeric = (value: string) => {
  return /^[a-zA-Z0-9]+$/.test(value);
};

export const isAirportCodeValid = (value: string) => {
  return /^[a-zA-Z]+$/.test(value);
};

// eslint-disable-next-line complexity
export const isAirportSearchStringValid = (value: string) => {
  const letterCount = value.replace(/[^a-zA-Z]/g, '').length;
  if (letterCount <= 2) {
    return /^[a-zA-Z.]+\s*$/.test(value) && !value.startsWith(' ');
  }
  return (
    /^[a-zA-Z .]+$/.test(value) &&
    !value.startsWith(' ') &&
    !value.endsWith(' ')
  );
};

export const basicFaresFieldCheckedValue = (
  catalogApiFieldsValue: CatalogApiFieldsValue | null,
  bookWidgetAem: BookWidgetAem | null
) => {
  let checked =
    stringToBoolean(bookWidgetAem?.defaultValues?.basicFaresChecked) !== false;

  if (catalogApiFieldsValue) {
    checked = checked && catalogApiFieldsValue?.basicFaresChecked !== false;
  }

  return checked;
};
